export default function ProcessingOfEmailAddressForFullTimeEmployeeContent() {
  return (
    <div className="p-3 flex flex-col space-y-3 whitespace-pre-wrap text-justify">
      <div>Szanowni Państwo,</div>
      <div>
        chcąc ułatwić Państwu komunikację z pracodawcą - InvenioQD sp. z o.o. -
        nasza firma uruchomiła „<span className="font-bold">invenio HR</span>” -
        nową aplikację webową (czyli dostępną pod adresem strony internetowej:
        „hr.invenio.pl”). Celem <span className="font-bold">invenio HR</span>{" "}
        jest umożliwienie Państwu dostępu do najważniejszych informacji oraz
        funkcji związanych z zatrudnieniem i organizacją pracy.
      </div>
      <div>
        Za pomocą aplikacji będą Państwo mogli w szczególności:
        <ul>
          <li>sprawdzić swój plan pracy (grafik),</li>
          <li>monitorować obecności oraz czas pracy,</li>
          <li>składać i śledzić wnioski urlopowe,</li>
          <li>przeglądać ogłoszenia firmowe i komunikaty,</li>
          <li>sprawdzać podsumowanie pracy oraz dane kadrowe.</li>
        </ul>
      </div>
      <div>
        Dostęp do aplikacji wymaga jedynie posiadania urządzenia z dostępem do
        internetu bez konieczności instalowania aplikacji na jakimkolwiek
        urządzeniu. Logowanie do aplikacji odbywa się przez przeglądarkę
        internetową. Przy pierwszym logowaniu wymagane będzie potwierdzenie
        tożsamości (np. numerem PESEL) oraz ustawienie hasła.
      </div>
      <div>
        Instrukcja oraz link do pierwszego logowania zostaną przesłane na
        Państwa adres e-mail. Po zalogowaniu w aplikacji dostępny będzie również
        samouczek oraz instrukcja korzystania z systemu, które przeprowadzą
        Państwa przez najważniejsze funkcje.
      </div>
      <div>
        Aplikacja jest bezpłatna, można w każdym momencie zrezygnować z jej
        używania, z faktem jej uruchomienia nie łączą się żadne formalności -
        poza wyrażeniem zgody na wykorzystanie podanego adresu e-mail (w celu
        korzystania z aplikacji konieczne jest przypisanie adresu e-mail do
        konta użytkownika).{" "}
        <span className="font-bold">
          Tym samym prosimy osoby, które chciałyby skorzystać z nowej aplikacji
          o przekazanie zgody na wykorzystanie adres e-mail
        </span>{" "}
        - zgodnie z podanym poniżej wzorem. W załączeniu także informacja o
        przetwarzaniu danych osobowych w powyższym zakresie.
      </div>
      <div>
        <span className="font-bold">
          Korzystanie z aplikacji nie jest obowiązkowe
        </span>
        , zachęcamy jednak do spróbowania tej formy kontaktu z pracodawcą.
      </div>
    </div>
  );
}
